import { Navigate } from 'react-router';

/** B8 (lote 09/10): endereço curto das Automações, que já foi o item fixo do menu lateral. */
export const CAMINHO_AUTOMACOES = '/automacoes';
/** FUN 2026-10-15 (U7): o painel do módulo Automações (menu próprio, por permissão). */
export const CAMINHO_PAINEL_AUTOMACOES = '/automacoes/automacoes/painel';

/**
 * B8 virou módulo na U7 (painel dos robôs do servidor Windows, `modules/automacoes`): o item fixo do menu saiu e o menu
 * "Automações" passou a ser o do módulo, filtrado por permissão como os outros. O endereço antigo leva ao painel; sem o
 * módulo ou sem a permissão, o painel mostra o "não encontrado" de sempre.
 */
export function RedirecionarAutomacoes() {
  return <Navigate to={CAMINHO_PAINEL_AUTOMACOES} replace />;
}
